import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h9",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m17 17 4 4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m21 17-4 4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "MailX";
const MailX = memo(themed(Icon));
export {
  MailX
};
//# sourceMappingURL=mail-x.js.map
